/* unplugin-vue-components disabled */import { render } from "./modify.vue?vue&type=template&id=1e5df804&scoped=true"
import script from "./modify.vue?vue&type=script&setup=true&lang=js"
export * from "./modify.vue?vue&type=script&setup=true&lang=js"

import "./modify.vue?vue&type=style&index=0&id=1e5df804&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5df804"],['__file',"src/components/ai-chat/ai-assistant/modify.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e5df804"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e5df804', __exports__)) {
    api.reload('1e5df804', __exports__)
  }
  
  module.hot.accept("./modify.vue?vue&type=template&id=1e5df804&scoped=true", () => {
    api.rerender('1e5df804', render)
  })

}


export default __exports__